<div class="text-primary mt-4 flex flex-col items-center justify-center gap-4 rounded-lg bg-white p-6 shadow-sm">
  <svg xmlns="http://www.w3.org/2000/svg" width="100px" height="100px" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M7.085 3A1.5 1.5 0 0 1 8.5 2h3a1.5 1.5 0 0 1 1.415 1H14.5A1.5 1.5 0 0 1 16 4.5v4.707A5.5 5.5 0 0 0 10.257 18H5.5A1.5 1.5 0 0 1 4 16.5v-12A1.5 1.5 0 0 1 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.125a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25" />
  </svg>
  <p class="text-primary text-[22px] font-light" i18n="@@dashboardMainNoPharmacies">No Registered Pharmacies</p>
  <a
    routerLink="/user/pharmacies/new-request"
    class="bg-primary hover-bg-primary-hover flex items-center justify-center gap-1 rounded-[8px] px-[8px] py-[4px] text-[14px] font-[500] text-[white] hover:cursor-pointer">
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
    </svg>
    <span i18n="@@dashboardMainRegisterNew">Register New Pharmacy</span>
  </a>
</div>
